/** @file Resolves the graph's active key (timeline + frame) to a track and key index of the shown tracks. */
import type { CurveActiveKey, CurveTrack } from './curveTypes';

/** The shown track and key index of `active`; null when it is not shown (another selection) or its key is gone. */
export function activeCurveKey(tracks: readonly CurveTrack[], active: CurveActiveKey | null): { track: number; key: number } | null {
  if (active === null) return null;
  const { ref, frame } = active;
  const track = tracks.findIndex((t) => t.ref.animation === ref.animation && t.ref.channel === ref.channel && t.ref.target === ref.target);
  const key = tracks[track]?.frames.indexOf(frame) ?? -1;
  return key < 0 ? null : { track, key };
}
